import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { colTableRef } from './consts';

export default grapesjs.plugins.add('gjs-data-table', (editor, opts = {}) => {
  let options = {
    pfx: 'data-table',
    blocks: [colTableRef],
    defaultStyle: true,
    labelTable: 'Data Table',
    labelFinderName: 'Filters',
    labelCMSCategory: 'CMS',
    labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
    ...opts,
  };
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
